var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('core-filter'),_c('core-toolbar'),(_vm.userRole !== 9)?_c('core-drawer'):_vm._e(),_c('core-view'),_c('core-overlay')],1)}
var staticRenderFns = []

export { render, staticRenderFns }